import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ImportadorService } from '../services/importadorXlsx/importadorXlsx.service';

const initialState = {};

const importadorService = new ImportadorService();
export const importadorSlice = createSlice({
  name: 'importador',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
  },
});

//se incluyen estas funciones en el slice ya que todos los llamados de los endpoints se manejan a traves de redux
export const uploadRegistroPM = createAsyncThunk('post_registro_pm', async (registroPm: File) => {
  return importadorService.uploadRegistroPM(registroPm)
});
export const uploadRegistroDJA = createAsyncThunk('post_registro_dja', async (registroDJA: File) => {
  return importadorService.uploadRegistroDJA(registroDJA)
});
export const getLastRegistro = createAsyncThunk('get_last_registro_dja_pm', async (queryParams: object) => {
  return importadorService.getLastRegistro(queryParams)
});
export const getLastDatesRegistros = createAsyncThunk('get_last_dates_registros', async () => {
  return importadorService.getLastDatesRegistros()
});

export default importadorSlice.reducer;
